import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, HandHeart } from 'lucide-react';
import { InlineText, InlineImage } from './InlineEditable';

export default function VolunteerCTA() {
  return (
    <section className="relative bg-cream">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
        <div className="relative overflow-hidden rounded-[32px] bg-ink-600 text-cream p-10 md:p-16 lg:p-20">
          <div className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-gold/15 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -left-32 w-[480px] h-[480px] rounded-full bg-coral/10 blur-3xl pointer-events-none" />
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)', backgroundSize: '24px 24px' }} />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 bg-cream/10 border border-cream/15 rounded-full px-4 py-1.5 text-[11px] uppercase tracking-widest text-gold">
                <HandHeart className="w-4 h-4" />
                <InlineText settingKey="home_volunteer_kicker" fallback="Gönüllü Olur Musunuz?" as="span" />
              </div>
              <InlineText settingKey="home_volunteer_title"
                fallback={'Birlikte daha <span class="italic text-coral-200">büyük</span><br /> hayallere dokunalım.'}
                as="h2" html multiline
                className="font-display text-4xl md:text-5xl lg:text-7xl mt-6 leading-[0.98]" />
              <InlineText settingKey="home_volunteer_text"
                fallback="YEKÜV'ün Türkiye genelindeki eğitim ve kültür faaliyetlerinde bireysel veya kurumsal olarak gönüllü olabilirsiniz. Değişime birlikte şekil verelim."
                as="p" multiline
                className="mt-6 max-w-xl text-cream/75 text-base md:text-lg leading-relaxed" />
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to="/gonullu" className="inline-flex items-center gap-2 bg-gold text-ink-700 rounded-full px-6 h-14 font-semibold hover:bg-gold-400 transition-colors">Gönüllülük Formu <ArrowUpRight className="w-4 h-4" /></Link>
                <Link to="/gonullu#kurumsal" className="inline-flex items-center gap-2 bg-transparent border border-cream/30 rounded-full px-6 h-14 font-medium hover:bg-cream/5 transition-colors">Kurumsal Gönüllülük</Link>
              </div>
            </div>
            <div className="lg:col-span-5 hidden lg:block">
              <div className="relative grid grid-cols-2 gap-3">
                <InlineImage settingKey="home_volunteer_image_1"
                  fallback="https://images.pexels.com/photos/7692546/pexels-photo-7692546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="" className="w-full aspect-[3/4] object-cover rounded-2xl translate-y-6" />
                <InlineImage settingKey="home_volunteer_image_2"
                  fallback="https://images.pexels.com/photos/18449721/pexels-photo-18449721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="" className="w-full aspect-[3/4] object-cover rounded-2xl" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
